import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const GearIcon = createIcon({
  displayName: 'GearIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M3.9 15.647l1.398.214c1.032.158 1.769 1.082 1.693 2.123l-.103 1.411c-.03.411.194.798.565.977l1.034.498c.371.179.814.112 1.117-.167l1.039-.96c.766-.708 1.948-.708 2.715 0l1.039.96c.303.28.745.346 1.117.167l1.036-.499c.37-.178.593-.564.563-.974l-.103-1.413c-.076-1.041.661-1.965 1.693-2.123l1.398-.214c.407-.062.735-.367.827-.769l.255-1.118c.092-.402-.071-.819-.411-1.051l-1.167-.799c-.861-.59-1.124-1.742-.604-2.647l.705-1.226c.205-.357.171-.804-.086-1.126l-.715-.897c-.257-.322-.685-.455-1.079-.334l-1.352.414c-.999.306-2.064-.207-2.448-1.178l-.518-1.313c-.152-.384-.523-.636-.936-.635l-1.146.003c-.413.001-.783.255-.933.64l-.505 1.298c-.38.977-1.45 1.494-2.452 1.186l-1.408-.432c-.395-.122-.825.012-1.082.336l-.71.898c-.257.325-.288.773-.079 1.13l.721 1.229c.531.906.271 2.069-.595 2.662l-1.153.79c-.34.233-.503.65-.411 1.051l.255 1.118c.091.403.419.708.826.77Z" />
        <path d="M13.916 10.084c1.058 1.058 1.058 2.774 0 3.832 -1.058 1.058-2.774 1.058-3.832 0 -1.058-1.058-1.058-2.774 0-3.832 1.058-1.058 2.774-1.058 3.832 0" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24h-24v-24Z" />
    </>
  ),
})

const Gear: FC<IconProps> = (props) => {
  return <CustomIcon as={GearIcon} {...props} />
}

export default memo(Gear)
